<!-- 角色列表 -->
<template>
  <qc-container title="角色权限">
    <search-box @reset-search="baseResetSearch" @action="loadData" v-model="searchObj.name" placeholder="请输入角色名称搜索">
      <template  #form-item>
        <el-form-item label="角色名称" >
          <el-input  style="width:240px" v-model="searchObj.name" placeholder="`请输入角色名称搜索`"
                    @keyup.enter.native="loadData()"></el-input>
        </el-form-item>
      </template>
      <t-button  @click="toEdit()" >添加</t-button>
    </search-box>

    <el-table :data="tableData"  stripe style="width: 100%" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column type="index" label="序号" width="100"></el-table-column>
      <el-table-column prop="name" label="角色" width="200"></el-table-column>
      <el-table-column prop="remark" label="说明" minWidth="400"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <b-button  @click="toEdit(scope.row.id,scope.row.name)">编辑</b-button>
          <b-button  @click="toDel(scope.row.id)">删除</b-button>
        </template>
      </el-table-column>
    </el-table>
      <page ref="page" @handle-page="handlePage"></page>
    <el-dialog
      v-loading="loading"
      :title="obj.id?'修改角色':'添加角色'"
      v-model="addDialog"
      width="60%"
      :before-close="closeDialog">
      <el-row :gutter="20" class="addRow">
        <el-col :span="3" class="tr">
          角色名称
        </el-col>
        <el-col :span="21">
          <el-input placeholder="角色名称" class="w300" v-model="obj.name"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="addRow">
        <el-col :span="3" class="tr">
          授权权限
        </el-col>
        <el-col :span="21" class="pt10">
          <role-tab ref="roleTab"></role-tab>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="addRow mt20 pb20">
        <el-col :span="3" class="tr">
          备注
        </el-col>
        <el-col :span="21">
          <el-input placeholder="备注" type="textarea" :rows="5" class="w500" v-model="obj.remark"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer pt20 mr10 pb20">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button @click="saveAdd()">确 定</el-button>
      </span>
    </el-dialog>
  </qc-container>
</template>

<script>
  import Page from "../../../components/base/page";
  import RoleTab from "../../../components/base/RoleTab";
  import QcContainer from "../../../components/el/layout/qc-container";
  import SearchBox from "../../../components/base/SearchBox";
  import TButton from "../../../components/el/t-button";
  import BButton from "../../../components/el/b-button";
  export default {
    name: "group",
    components: {BButton, TButton, SearchBox, QcContainer, RoleTab, Page},

    data() {
      return {
        loading: false,
        searchObj: {name:'',source:source},
        tableData: [],
        obj:{name:'',ids:[],source:source,remark:""},
        addDialog:false,

      }
    },
    mixins: [tableBase],
    methods: {
      loadData(){
        if(this.searchObj.source===2){
          this.loadPageData("/api/mgr/shop/user/group/list");
        }else{
          this.loadPageData(Api.userGroup+"list");
        }
      },
      toEdit(id,name){
        if($.isNotEmpty(id)){
          this.$nextTick(function(){
              this.simpleGet(Api.userGroup+"getAuthList",{id:id},result=>{
                  this.obj = {id:id,name:name,ids:result.data,source:source};
                  this.$refs['roleTab'].setKeys(result.data);
              });
          });
        }else{
          this.obj = {name:'',ids:[],source:source,remark:""};
        }
        this.addDialog = true;
      },
      toDel(id){
        this.msgConfirm(Api.userGroup+"delete",{id:id},result=>{
            this.loadData();
        });
      },
      closeDialog(){
        this.addDialog = false;
      },
      saveAdd(){
        if($.isEmpty(this.obj.name)){
          this.$message.error("角色名不能为空");
        }else{
          this.obj.ids = this.$refs['roleTab'].getKeys();
          this.obj.contentType=_CONTENT_TYPE_JSON;
          let url;
          if(this.searchObj.source===2){
            url = "/api/mgr/shop/user/group/addOrUpdate"
          }else{
            url = Api.userGroup+"addOrUpdate";
          }
          this.simplePost(url,this.obj,result=>{
            this.obj={name:'',ids:[],source:source};
            this.$refs['roleTab'].resetTree();
            this.addDialog = false;
            this.loadData();
          });
        }
      }
    },
    mounted() {
      this.loadData();
    }
  }
</script>


<style lang="less" scoped>


</style>
